export default __webpack_public_path__ + "static/media/1.VALIDACION_WEB_SFS.b73c10a9.mp4";